import { toast } from '@/utils/prompt';

export function throttle () {
  // 利用闭包保存时间
  let prev = Date.now();
  return (fn, delay = 200) => {
    const context = this;
    const arg = arguments;
    const now = Date.now();
    if (now - prev >= delay) {
      fn.apply(context, arg);
      prev = Date.now();
    }
  };
}

/**
 * 粘贴板复制
 * @param text 复制文本
 * @param success 复制成功回调
 */
export function setClipboardData(text = '', success) {

  if (!text) {
    return false;
  }
  const input = document.createElement('input');
  input.setAttribute('readonly', 'readonly');
  input.setAttribute('value', text);
  document.body.appendChild(input);
  input.setSelectionRange(0, 9999);
  input.select();
  if (document.execCommand('copy')) {
    document.execCommand('copy');
    toast('复制成功');
    success && success();
  }
  document.body.removeChild(input);










}
export function getQueryVariable(variable, query) {
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return (false);
}
/**
 * @module getUrlParams
 * @description 获取url中的参数，可以
 * @param {String} url 一个url地址或者search
 * @returns {*} 返回一个对象
 */
export function getUrlParamsToObj(url) {
  if (!url) {
    return {};
  }
  // 兼容例如sence参数的格式： id=1212&name=lisi
  if (!uni.$u.test.url(url) && !url.startsWith('?')) {
    url = `?${url}`;
  }
  const urlParams = url.match(/([?&])(.+?=[^&]+)/igm);
  return urlParams ? urlParams.reduce((a, b) => {
    const value = b.slice(1).split('=');
    a[value[0]] = value[1];
    return a;
  }, {}) : {};
}
export const isNmuber = (str) => {
  return Object.prototype.toString.call(str) === '[object Number]';
};
export const isObject = (str) => {
  return Object.prototype.toString.call(str) === '[object Object]';
};
export const y = (e) => {
  if (e === 0 || e === '') return '';
  const n = e + '';
  return n.length < 2 ? '0' + n : n;
};
export const formatDuring = (e, n = 'hms') => {
  if (isNmuber(e - 0)) {
    const t = 6e4;
    const r = 60 * t;
    const u = 24 * r;
    const o = parseInt(e / u);
    const i = parseInt(e % u / r);
    const a = 24 * o + i;
    const c = parseInt(e % r / t);
    const s = 60 * a + c;
    const f = Math.floor(e % t / 1e3);
    const l = e % 1e3; const d = {
      dhmms: `${o}天${i}时${c}分${f}秒${l}毫秒`,
      dhms: `${o}天${i}时${c}分${f}秒`,
      hms: `${a}小时${c}分${f}秒`,
      ms: `${s}分${f}秒`,
      s: Math.floor(e / 1e3) + '秒',
      mms: e,
      mediumObject: {
        days: o,
        hours: i,
        minutes: c,
        seconds: f,
        millisecond: l,
      },
    };
    const p = /(^d)(?!h)/g.test(n);
    const _ = /((^d)(?!h))|((^h|^hh)(?!m))/g.test(n);
    const m = {
      d: o,
      h: p ? i : a,
      hh: y(p ? i : a),
      m: _ ? c : s,
      mm: y(_ ? c : s),
      s: f,
      ss: y(f),
      ms: l,
    };
    return d[n] || n.replace(/([dhms]{1,2})/g, e => m[e]);
  }
  throw new Error('需要被转换的毫秒数不能为空');
};

export function isEmptyObject(o) {
  if (isObject(o)) {
    for (const key in o) {
      if (Object.prototype.hasOwnProperty.call(o, key)) return false;
    }
    return true;
  }
  return false;
}
export function setQuery(queryObj) {
  if (queryObj && isObject(queryObj) && !isEmptyObject(queryObj)) {
    const _list = [];
    for (const key in queryObj) {
      if (queryObj[key] !== undefined && queryObj[key] !== null) {
        _list.push(key + '=' + queryObj[key]);
      }
    }
    return _list.join('&');
  }
  return '';
}

/**
 * 获取页面唯一key
 * @it {Object} it vue实例
 * @returns {String} 页面唯一key字符串
 */
export function getPageKey(it) {
  while (it && it.mpType && it.mpType !== 'page') {
    it = it.$parent;
  }
  if (!it) {
    new TypeError('uniapp框架已修改实现，请检查工具函数方法getPageKey并修复');
  }
  // 过滤掉启动时
  if (!it?.$mp.page) {
    return '';
  }
  return `${it.$mp.page.route}:${it._uid}`;
}
